import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DownloadOutlinedIcon } from '@getgo/chameleon-icons/react';
import { IconButton } from '@getgo/chameleon-web/react';
import { DialogContent } from '@material-ui/core';
import Dialog from "../Dialog";
import classes from './ThumbnailDialog.module.scss';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
const ThumbnailDialog = ({ fileUrl, title, open, onClose, onDownload, }) => {
    console.warn('ThumbnailDialog is deprecated, use @ucc-messaging/inbox-common-ui instead');
    return (_jsx(Dialog, Object.assign({ className: classes.dialog, size: "lg", open: open, title: title, onClose: onClose }, { children: _jsx(DialogContent, Object.assign({ className: classes.content }, { children: _jsxs("div", Object.assign({ className: classes.imageContainer }, { children: [_jsx("img", { className: classes.image, src: fileUrl, alt: title }, void 0), onDownload && (_jsx(IconButton, Object.assign({ variant: "secondary", onClick: () => onDownload(), className: classes.download }, { children: _jsx(DownloadOutlinedIcon, {}, void 0) }), void 0))] }), void 0) }), void 0) }), void 0));
};
export default ThumbnailDialog;
//# sourceMappingURL=ThumbnailDialog.js.map